import * as React from 'react';
import { Component } from 'react';
import { MetroLineProps, ViewMode, Configuration } from 'app/components/metro-line/types';
import { TabContainer } from 'app/components/tabs/tab-container/tab-container';
import { TabItemWrapper } from 'app/components/metro-line/tab-item-wrapper';
import { getSectionId } from 'app/components/metro-line/helpers';

export class MetroLine<SectionType> extends Component<MetroLineProps<SectionType>> {

  private tabsFactory = (configuration: Configuration<SectionType>[], activeSection: SectionType,
    translation: any) => {

    return (onClick) => <ul id="tabcontainer" role="tablist" onClick={onClick}>
      {configuration.map((item, index) =>
        <TabItemWrapper<SectionType>
          key={String(item.section)}
          id={index}
          item={item}
          active={activeSection === item.section}
          valid={item.isValid}
          warnings={item.hasWarnings}
          activeMode={this.props.activeMode}
          translation={translation}
          anchorId={getSectionId(item.section)}
          itemRef={item.ref}
          updateActiveSection={this.props.updateActiveSection}
        />)}
    </ul>;
  };

  public render() {
    const { configuration, translation, changeViewMode, activeSection, activeMode, forceMode, label } = this.props;

    const renderTabs = this.tabsFactory(configuration, activeSection, translation);

    return <TabContainer
      changeViewMode={!forceMode ? changeViewMode : undefined}
      label={label || translation.label}
      visible={!!configuration && configuration.filter(f => !!f.visible).length > 1}
      expandAll={activeMode === ViewMode.scroll}
      activeSection={String(activeSection)}
      hasError={configuration && configuration.some(conf => !!conf && conf.isValid === false)}
      translation={this.props.translation}
      renderTabs={renderTabs} />;
  }
}
